import { Injectable } from '@angular/core';
import { BaseMapper } from '@shared/data';
import { BookingEligibilityDto } from '../dto/booking-eligibility.dto';
import { BookingEligibilityModel } from '../model/booking-eligibility.model';

@Injectable({
    providedIn: 'root',
})
export class BookingEligibilityMapper extends BaseMapper<BookingEligibilityDto, BookingEligibilityModel> {
    mapDtoToModel(dto: BookingEligibilityDto): BookingEligibilityModel {
        return {
            isCoveredByPlan: dto.isCoveredByPlan,
            isQuotaExceeded: dto.isQuotaExceeded,
        };
    }
}
